import cx from 'classnames';
import { forwardRef, type ReactNode } from 'react';

import { type ForwardRefComponent } from '../../@types/types';
import { Box, type BoxProps } from '../box';

import * as theme from './theme.css';

export type Gap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export interface FlexProps extends Omit<BoxProps, 'ref' | 'flexDirection'> {
  children?: ReactNode;
  gap?: Gap;
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  /** A class name for the flex element to give custom styles. */
  className?: string;
}

const Flex: ForwardRefComponent<FlexProps, HTMLDivElement> = forwardRef<HTMLDivElement, FlexProps>(
  ({ children, direction = 'row', gap = 0, className, ...rest }, ref) => {
    const classNames = cx(
      {
        [theme[`gap-${gap}`]]: gap > 0,
      },
      className,
    );

    return (
      <Box display="flex" boxSizing="border-box" flexDirection={direction} className={classNames} ref={ref} {...rest}>
        {children}
      </Box>
    );
  },
);

Flex.displayName = 'Flex';

export default Flex;
